import React, { useEffect, useState } from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { GetCountries, GetState, GetCity } from 'react-country-state-city'

interface CityInputProps {
  value: string | undefined;
  stateCode: string | undefined;
  onChange: (event: any, newValue: string) => void;
  error?: boolean;
  helperText?: string;
  placeholder?: string;
  disabled?: boolean;
  paperSx?: any;
  inputSx?: any;
  size?: 'small' | 'medium';
  required?: boolean;
}

export const CityInput = ({
  value,
  stateCode,
  onChange,
  error,
  helperText,
  placeholder = "City",
  disabled,
  paperSx,
  inputSx,
  size,
  required
}: CityInputProps) => {
  const [cities, setCities] = useState<any[]>([])

  useEffect(() => {
    if (!stateCode) {
      setCities([])
      return
    }

    GetCountries().then((countries: any) => {
      const us = countries.find((c: any) => c.iso2 === 'US')
      if (!us?.id) return
      GetState(us.id).then((states: any) => {
        const stateObj = states.find((s: any) => s.state_code === stateCode)
        if (stateObj) {
          GetCity(us.id, stateObj.id).then((cityResult: any) => {
            setCities(cityResult)
          })
        } else {
          setCities([])
        }
      })
    })
  }, [stateCode])

  return (
    <Autocomplete
      key={stateCode || 'empty'}
      freeSolo={cities.length === 0}
      fullWidth
      disableClearable
      forcePopupIcon={false}
      disabled={disabled}
      autoHighlight
      autoSelect
      slotProps={{
        paper: { sx: paperSx },
        popper: { disablePortal: true }
      }}
      options={cities.map((c) => c.name)}
      value={value || ''}
      onChange={(_e, newValue) => {
        onChange(_e, (newValue as string) || '')
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          required={required}
          size={size}
          sx={inputSx}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          FormHelperTextProps={{ sx: { marginLeft: 0, marginRight: 0 } }}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  )
}